import React from 'react';

export const Corded = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 88.45 88.45"
    >
      <defs>
        <clipPath id="clip-path">
          <circle fill="none" cx="44.22" cy="44.22" r="36.5" />
        </clipPath>
      </defs>
      <circle
        fill="#fff"
        stroke="#27375f"
        strokeWidth="1.45px"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="44.22"
        cy="44.22"
        r="43.5"
      />
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(18.11 71.84) rotate(37.91)"
      >
        C
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(25.97 77.67) rotate(22.14)"
      >
        O
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="matrix(0.99, 0.11, -0.11, 0.99, 36.48, 81.47)"
      >
        R
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(45.97 82.3) rotate(-8.51)"
      >
        D
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="translate(56.27 80.35) rotate(-22.92)"
      >
        E
      </text>
      <text
        fontSize="11px"
        fill="#010101"
        fontFamily="Lato-Bold, Lato"
        fontWeight="700"
        transform="matrix(0.8, -0.61, 0.61, 0.8, 64.12, 76.84)"
      >
        D
      </text>
      <g clipPath="url(#corded-clip-path)">
        <rect
          strokeWidth="0.84px"
          fill="#27375f"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="37.43"
          y="-8.85"
          width="3.02"
          height="42.94"
        />
        <rect
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.03px"
          fill="#27375f"
          stroke="#fff"
          x="48"
          y="-8.85"
          width="3.02"
          height="64.01"
        />
        <path
          strokeMiterlimit="10"
          strokeWidth="0.77px"
          fill="#27375f"
          stroke="#fff"
          d="M38.19,21.33h1.49a4.09,4.09,0,0,1,4.09,4.09V42a0,0,0,0,1,0,0H34.1a0,0,0,0,1,0,0V25.42A4.09,4.09,0,0,1,38.19,21.33Z"
        />
        <path
          strokeMiterlimit="10"
          strokeWidth="0.77px"
          fill="#27375f"
          stroke="#fff"
          d="M48.77,45.05h1.49a4.09,4.09,0,0,1,4.09,4.09V65.72a0,0,0,0,1,0,0H44.68a0,0,0,0,1,0,0V49.14a4.09,4.09,0,0,1,4.09-4.09Z"
        />
      </g>
    </svg>
  );
};
